var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loyalty-levels"},[_c('MenuHeader',{attrs:{"text":_vm.$t('loyalty.levels'),"icon":"icons/wallet.svg"}}),_c('Levels')],1)}
var staticRenderFns = []

export { render, staticRenderFns }